import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { MdInputContainer, MdDatepicker, MdInputDirective } from '@angular/material';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { NceService } from '../services/nce.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { FileService } from '../../shared/services/file.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'nce-make-appointment',
    templateUrl: 'make-appointment.component.html'
})

export class NceMakeAppointmentComponent implements OnInit{

    @ViewChild('fileInput') vFileInput;

    vSelectedDate: Date;
    vSelectedTime: String = '';
    vSelectedTimeDesc: String = '';
    vContactName: String = '';
    vContactPhoneNumber: String = '';

    minDate: Date = new Date();
    //updatedDate: Date = new Date();

    counter = 0;
    countTime = 0;

    currFile: number;

    constructor(
        private _nceService: NceService,
        private _pageNavigationService: PageNavigationService,
        private _fileService: FileService,
        private _layoutService: LayoutService,
        private _popupService: PopupService,
        private _storageService: StorageService,
        private _location: Location,
        private _errorService: ErrorService,
    ) { }


    ngOnInit() {
        this._layoutService.setCurrentPage('nce-make-appointment');
        if(this._nceService.getNCEID().nce_record_id === ''){
            this._pageNavigationService.navigate(['home']);
            return;
        }
        this.loadAppointmentAvailability();
        this.minDate.setDate(this.minDate.getDate() + 1);
        this._nceService.resetError();
    }

    loadAppointmentAvailability(){
        this._nceService.loadAppointmentAvaibility().then(
            (resolve) => {
                //this.updatedDate = new Date(this.getAppointmentAvailability().updated_date);
                this._nceService.loadDetailNCE(this._nceService.getNCEID().nce_record_id).then(
                    (resolve) => {
                        if(this.getDetailNCE().status_description !== STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE){
                            this._pageNavigationService.navigate(['home']);
                        } else {
                            this._fileService.vFiles = this.getDetailNCE().attachment.appointment !== undefined ? this.getDetailNCE().attachment.appointment : [];
                            this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
                        }
                    }, 
                    (reject) => {
                        this.openRetryAppointmentPopup();
                    }
                )
            },
            (reject) => {
                this.openRetryAppointmentPopup();
            }
        );
    }

    openRetryAppointmentPopup(){
        this._popupService.closePopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Sorry, something went wrong',
            buttons: {
                CANCEL: {
                    text: 'Retry',
                    function: () => {
                        this._popupService.closePopup();
                        this.loadAppointmentAvailability();
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        this._storageService.removeSessionItem('nceFiles');
        this._storageService.removeSessionItem('nceMultipleFiles');
        this._storageService.removeSessionItem('nceNewMultipleFiles');
        this._storageService.removeSessionItem('extensionNCE');
        this._nceService.resetUploadDocumentData();
        this._nceService.vListTime = [];
    }

    getDetailNCE(){
        return this._nceService.getDetailNCE();
    }

    isNoAvailableTime(){
        this.countTime = 0;
        for(let timeType of this.getListTime()){
            if(!timeType.availability) {
                this.countTime ++;
            }
        }
        return this.countTime === this.getListTime().length;
    }

    getListTime(){
        return this._nceService.getListTime();
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    isLoadingAttachment(){
        return this._fileService.isLoading();
    }

    getAppointmentAvailability(){
        return this._nceService.getAppointmentAvaibility();
    }

    getAppointmentDate(){
        return this.vSelectedDate;
    }

    getFileList(){
        return this._fileService.getFileLists();
    }

    isDisableMakeAppointment(){
        return ( this.vSelectedDate === undefined) || ( this.vSelectedTime === undefined || this.vSelectedTime === '' ||  
        // this.getFileList()[0] == undefined || this.getFileList()[0] === '' || 
        this.vContactName === '' || this.vContactPhoneNumber === '');
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    /*myFilter = (d: Date): boolean => {
        const day = d.getDay();
        if(this.getAppointmentAvailability().holiday.some(x => x === (d.getMonth() + 1) + '-' + d.getDate()) || (day == 0 || day == 6)){
            return false;
        }else{
            if(this.counter < this.getAppointmentAvailability().days && d.getTime() >= this.updatedDate.getTime()){
                this.counter++;
                this.minDate = d;
                if(this.counter == this.getAppointmentAvailability().days){
                    return true;
                }
                return false;
            }
            return true;
        }
    }

    resetCounter(){
        console.log(this.minDate);
        if(this.counter < this.getAppointmentAvailability().days){
            this.counter = 0;
        }
    }*/

    resetCounter(){
        let updated_date = new Date(this.getAppointmentAvailability().updated_date);
        let today = new Date();
        let day = updated_date.getDay();
        while(this.counter < this.getAppointmentAvailability().days){
            day = updated_date.getDay();
            if(!(this.getAppointmentAvailability().holiday.some(x => x === (updated_date.getMonth() + 1) + '-' + updated_date.getDate()) || day == 0 || day == 6)){
                this.counter++;
                this.minDate = updated_date;
            }
            updated_date.setDate(updated_date.getDate() + 1);
        }
        let buffer = this.getAppointmentAvailability().buffer ? this.getAppointmentAvailability().buffer : 0;
        if(this.minDate.getTime() < today.getTime()){
            today.setDate(today.getDate()+ 1+ buffer);
            this.minDate = today;
        }
    }

    myFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Rama requested that 1 day after holiday to be blocked
        function calculateNextDate(holidayString : string) {
            let dateNow = new Date();
            dateNow = new Date (dateNow.getFullYear() + '-' + holidayString.split('-')[0] + '-' + holidayString.split('-')[1]);
            dateNow.setDate(dateNow.getDate() + 1); // this is where we add the date
            return (dateNow.getMonth() +  1) + '-' + dateNow.getDate();
        }
        if(
            this.getAppointmentAvailability().holiday.some(x => x === (d.getMonth() +  1) + '-' + d.getDate()) || 
            this.getAppointmentAvailability().holiday.some(x => calculateNextDate(x) === (d.getMonth() +  1) + '-' + d.getDate()) || 
            (day == 0 || day == 6)
            ){
            return false;
        }
        return true;
    }

    setTime(pSelectedTime, pSelectedTimeDesc){
        this.vSelectedTime = pSelectedTime;
        this.vSelectedTimeDesc = pSelectedTimeDesc;
    }

    checkAvailableTime(pSelectedDate){
        this.vSelectedTime = '';
        this.vSelectedTimeDesc = '';
        this._nceService.loadAvailableTime(pSelectedDate, 'appointment');
    }

    makeAppointment(){
        if(/^\+?\d+$/.test(this.vContactPhoneNumber.toString()) && this.vContactPhoneNumber == '' && this.vContactPhoneNumber == null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Mobile No provided is not valid');
            return;
        } else if(this.vContactPhoneNumber.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Mobile No length must be more than 8');
            return;
        }
        this._nceService.openSaveConfirmationPopup('Book on', this.vSelectedDate.getDate() + '-' +(this.vSelectedDate.getMonth()+1) + '-' + this.vSelectedDate.getFullYear() + ' '
        + this.vSelectedTimeDesc,
        'appointment', this.vSelectedDate, this.vSelectedTime, this.vContactName, this.vContactPhoneNumber);
    }

    goBack(){
        this._location.back();
    }

    fileEvent(fileInput: any){
        let file = fileInput.target.files[0];
        this.currFile = this._fileService.vFiles.length;
        if(!this._fileService.validateUploadedFile(file)){
            this.vFileInput.nativeElement.value = "";
            return;
        }
        this._fileService.vFiles.push(file.name);
        this._fileService.getSignedRequest(file, 'nce', 'appointment', this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id);
        this.vFileInput.nativeElement.value = "";
    }

    removeAttachment(pIndex, pFileName){
        this.currFile = pIndex;
        this._fileService.deleteFiles(this._nceService.getNCEID().nce_request_id, 'nce', 'appointment' , pFileName).then(
            (resolve) => {
                this._fileService.vFiles.splice(pIndex, 1);
                this._popupService.openGeneralConfirmationPopup('Notice', 'File successfully deleted', '', false, false);
                this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
            },
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Notice', 'Error delete file, please try again', '', false, false);
            }
        );
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/make-appointment.component.ts